import S from './AwardEdit.module.scss';
import C from '../../Resume.module.scss';
import 'react-datepicker/dist/react-datepicker.css';

import React, { Dispatch, SetStateAction, useEffect, useState, FocusEvent } from 'react';
import { AwardType, ResumeType } from '../../../../../types/ResumeTypes';
import { DateTimeUtils } from '../../../../../utils/DateTimeUtils';
import SelectDateBox from '../../../../common/SelectDateBox';
import { DummyAward } from '../../../../../constants/IvyConstants';

interface AwardEditProps {
  awards: AwardType[];
  setResume: Dispatch<SetStateAction<ResumeType>>;
}

const AwardEdit = (props: AwardEditProps) => {
  const { awards, setResume } = props;

  const addAward = (data: AwardType) => {
    setResume((prevResume) => {
      const awards = [...prevResume.awards] || [];
      awards.push(data);

      return {
        ...prevResume,
        awards,
      };
    });
  };

  const removeAward = (index: number) => {
    setResume((prevResume) => {
      const updatedAwards = [...prevResume.awards];
      if (updatedAwards.length === 1) {
        return {
          ...prevResume,
          awards: [],
        };
      } else {
        updatedAwards.splice(index, 1); // 해당 index의 요소를 제거
        return {
          ...prevResume,
          awards: updatedAwards,
        };
      }
    });
  };

  useEffect(() => {
    if (awards !== undefined && awards.length === 0) {
      // addAward(makeDummyAwards());
    }
  }, [awards]);

  return (
    <>
      <section className={`${C.basic_edit_section} wrapper`}>
        <div className={C.basic_wrap}>
          <div className={C.basic_title}>
            <p className="b1">수상실적</p>
          </div>
          <div className={C.basic_input_wrap}>
            {awards?.map((award, index) => {
              return (
                <React.Fragment key={`award-edit-${index}`}>
                  <AwardEditElement index={index} award={award} setResume={setResume} />
                  <button
                    className={`${C.plus_minus_button} ${C.minus_button}`}
                    onClick={() => {
                      removeAward(index);
                    }}
                  ></button>
                  <hr />
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className={C.plus_button_area}>
          <button
            className={`${C.plus_minus_button} ${C.plus_button}`}
            onClick={() => {
              addAward(DummyAward);
            }}
          ></button>
        </div>
        <hr />
      </section>
    </>
  );
};

interface AwardEditElementProps {
  index: number;
  award: AwardType;
  setResume: Dispatch<SetStateAction<ResumeType>>;
}

const AwardEditElement = (props: AwardEditElementProps) => {
  const { index, award, setResume } = props;
  const [isAwardNameFocused, setIsAwardNameFocused] = useState<boolean>(false);
  const [isAwardInstFocused, setIsAwardInstFocused] = useState<boolean>(false);

  const updateField = (index: number, fieldName: keyof AwardType, value: string) => {
    setResume((prevResume) => {
      const updatedAwards = [...prevResume.awards];
      updatedAwards[index] = {
        ...updatedAwards[index],
        [fieldName]: value,
      };

      return {
        ...prevResume,
        awards: updatedAwards,
      };
    });
  };

  const updateAwardDateField = (value: Date, index: number) => {
    updateField(index, 'at', DateTimeUtils.toDateString(value));
  };

  const blurEventHandle = (setFocused: Function, e: FocusEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      setFocused(false);
    } else {
      setFocused(true);
    }
  };

  const checkInputValue = () => {
    if (award.name !== '') {
      setIsAwardNameFocused(true);
    }

    if (award.institution !== '') {
      setIsAwardInstFocused(true);
    }
  };

  useEffect(() => {
    checkInputValue();
  }, []);

  return (
    <>
      <div className={`${C.basic_edit_input} ${S.language_edit_input}`}>
        {/* 수상내용 */}
        <div className="input-grp">
          <label
            htmlFor={`award_name_${index}`}
            className={isAwardNameFocused ? 'input-label focus-on' : 'input-label'}
          >
            수상명
          </label>
          <input
            type="text"
            id={`award_name_${index}`}
            className="input-text input-border"
            onFocus={() => {
              setIsAwardNameFocused(true);
            }}
            onBlur={(e) => {
              blurEventHandle(setIsAwardNameFocused, e);
            }}
            onChange={(e) => {
              updateField(index, 'name', e.target.value);
              setIsAwardNameFocused(true);
            }}
            value={award.name}
          />
        </div>
        {/* 수상일 */}
        <div className={C.resume_period_date}>
          <SelectDateBox
            selectedDate={DateTimeUtils.stringToDateType(award.at, 'YYYY-MM-dd')}
            setSelectedDate={updateAwardDateField}
            type={'award-at-date'}
            index={index}
          />
        </div>
        {/* 발급기관 */}
        <div className="input-grp">
          <label
            htmlFor={`award_institution_${index}`}
            className={isAwardInstFocused ? 'input-label focus-on' : 'input-label'}
          >
            발급기관
          </label>
          <input
            type="text"
            id={`award_institution_${index}`}
            className="input-text input-border"
            onFocus={() => {
              setIsAwardInstFocused(true);
            }}
            onBlur={(e) => {
              blurEventHandle(setIsAwardInstFocused, e);
            }}
            onChange={(e) => {
              updateField(index, 'institution', e.target.value);
              setIsAwardInstFocused(true);
            }}
            value={award.institution}
          />
        </div>
      </div>
      <div className={C.basic_wrap}>
        <div
          className={`${C.basic_edit_input} ${C.resume_textarea} input-grp input-textarea-height`}
        >
          <label htmlFor={`award_description_label_${index}`} className="textarea-label focus-on">
            상세내용
          </label>
          <textarea
            id={`award_description_label_${index}`}
            className="input-text input-border"
            value={award.description}
            onChange={(e) => updateField(index, 'description', e.target.value)}
          />
        </div>
      </div>
    </>
  );
};

export default AwardEdit;
